import script from "./CemiterioDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CemiterioDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CemiterioDashboard.vue?vue&type=style&index=0&id=694a678a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-694a678a"]])

export default __exports__